import { InjectableConstructor } from './Injectable';
import { BaseModule } from './Module';
import { OrganizedSystemOperations } from './System';

export const ENGINE_TOKEN = Symbol.for('Engine');
export const ENGINE_OPTIONS_TOKEN = Symbol.for('EngineOptions');

export interface BaseEngine extends BaseModule {
  registerSystemOperations(systemOperation: OrganizedSystemOperations): void;
}

export type EngineConstructor<Engine extends BaseEngine = BaseEngine> = InjectableConstructor<Engine>;

export type BaseEngineOptions = {};
